export const connections = {
    unload: 'https://unload.viortis.kz/',
    catalog: 'https://catalog.viortis.kz/',
    report: 'https://report.viortis.kz/',
    identity: 'https://identity.viortis.kz/'
}

export default {
    connections
}